import Vue from 'vue';
import axios from 'axios';
import { Client } from '@/api'
// @ts-ignore
import VueSlideoutPanel from 'vue2-slideout-panel';
import './plugins/bootstrap-vue';
// @ts-ignore
import VCalendar from 'v-calendar';
import VueScrollTo from 'vue-scrollto';
import Loading from 'vue-loading-overlay';
import dayjs from 'dayjs';
import App from './App.vue';
import router from './router';
import store from './store';
import './scss/global.scss';
import 'vue-loading-overlay/dist/vue-loading.css';
import CImg from './components/CImg.vue'

Vue.use(Loading);
Vue.use(VueScrollTo);
Vue.use(VueSlideoutPanel);

Vue.component('c-img', CImg)

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

Vue.prototype.formatDate = (date: any) => dayjs(date).format('DD-MM-YYYY');

Vue.use(VCalendar, {
  componentPrefix: 'v',
});

const bus = new Vue();
// @ts-ignore
window.bus = bus;
if (process.env.VUE_APP_API_URL) {
  Client.setBase(process.env.VUE_APP_API_URL)
} else {
  Client.setBase(`https://${window.location.hostname}/api`)
}

store.dispatch('auth/attempt').then(() =>
new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    this.$store.dispatch('invoices/getInvoices');
  },
}).$mount('#app'));
